import {
  RadioGroupField,
  SelectField,
  TextField,
} from "$components/rhf-fields";
import { NationalIdOwner, NationalIdType } from "elephant-web/gql";
import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";

export const PakistanNationalIdInputs: FC<{
  fieldNames: { nationalId: { number: string; type: string; owner: string } };
}> = ({ fieldNames }) => {
  const { formatMessage } = useIntl();
  const { watch } = useFormContext();
  const idType = watch(fieldNames.nationalId.type);

  return (
    <>
      <RadioGroupField
        fullWidth
        name={fieldNames.nationalId.type}
        label={formatMessage({
          id: "patient.generalSection.pakistan.nationalIdType.label",
          defaultMessage: "CNIC Type",
        })}
        options={[
          {
            value: NationalIdType.Primary,
            label: formatMessage({
              defaultMessage: "Primary",
              id: "patient.generalSection.pakistan.nationalIdType.primary.label",
            }),
          },
          {
            value: NationalIdType.Secondary,
            label: formatMessage({
              defaultMessage: "Secondary",
              id: "patient.generalSection.pakistan.nationalIdType.secondary.label",
            }),
          },
        ]}
        required
      />
      {idType === NationalIdType.Secondary && (
        <SelectField
          id="national-id-owner"
          fullWidth
          options={[
            {
              value: NationalIdOwner.Father,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.father",
                defaultMessage: "Father",
              }),
            },
            {
              value: NationalIdOwner.Mother,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.mother",
                defaultMessage: "Mother",
              }),
            },
            {
              value: NationalIdOwner.Husband,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.husband",
                defaultMessage: "Husband",
              }),
            },
            {
              value: NationalIdOwner.Wife,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.wife",
                defaultMessage: "Wife",
              }),
            },
            {
              value: NationalIdOwner.Brother,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.brother",
                defaultMessage: "Brother",
              }),
            },
            {
              value: NationalIdOwner.Sister,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.sister",
                defaultMessage: "Sister",
              }),
            },
            {
              value: NationalIdOwner.Son,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.son",
                defaultMessage: "Son",
              }),
            },
            {
              value: NationalIdOwner.Daughter,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.daughter",
                defaultMessage: "Daughter",
              }),
            },
            {
              value: NationalIdOwner.MotherInLaw,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.motherInLaw",
                defaultMessage: "Mother in law",
              }),
            },
            {
              value: NationalIdOwner.FatherInLaw,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.fatherInLaw",
                defaultMessage: "Father in law",
              }),
            },
            {
              value: NationalIdOwner.SisterInLaw,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.sisterInLaw",
                defaultMessage: "Sister in law",
              }),
            },
            {
              value: NationalIdOwner.BrotherInLaw,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.brotherInLaw",
                defaultMessage: "Brother in law",
              }),
            },
            {
              value: NationalIdOwner.Other,
              label: formatMessage({
                id: "patient.generalSection.pakistan.nationalIdOwner.label.other",
                defaultMessage: "Other",
              }),
            },
          ]}
          name={fieldNames.nationalId.owner}
          required
          label={formatMessage({
            id: "patient.generalSection.pakistan.nationalIdOwner.label",
            defaultMessage: "CNIC Owner",
          })}
          data-testid="nationalIdOwnerSelectBox"
        />
      )}
      <TextField
        id="national-id-number"
        fullWidth
        name={fieldNames.nationalId.number}
        label={formatMessage({
          id: "patient.generalSection.pakistan.nationalIdNumber.label",
          defaultMessage: "CNIC Number",
        })}
        required
      />
    </>
  );
};
